module.exports = require("../vinyl/vinyl-fs.js");